// component
import TransHandle from './trans-handle.vue';
import CreatContract from './creat-contract/creat-contract.vue';
import Checkidealpeople from './check-ideal-people/check-ideal-people.vue';

export default [
  {
    path: '',
    name: 'transhandle',
    component: TransHandle,
    meta: {
      title: '处理',
      breadCrumbShowIndexArr: [0, 3, 2]
    }
  },
  {
    path: 'creatcontract',
    name: 'creatcontract',
    component: CreatContract,
    meta: {
      title: '创建合同',
      breadCrumbShowIndexArr: [0, 3, 2, 4]
    }
  },
  {
    path: 'checkidealpeople',
    name: 'checkidealpeople',
    component: Checkidealpeople,
    meta: {
      title: '审核成交人',
      breadCrumbShowIndexArr: [0, 3, 2, 4]
    }
  }
];
